module.exports = __webpack_public_path__ + "static/media/our-vision-header@3x.12be3098.jpg";